import { render, staticRenderFns } from "./mesh.vue?vue&type=template&id=19a756ee&"
import script from "./mesh.vue?vue&type=script&lang=js&"
export * from "./mesh.vue?vue&type=script&lang=js&"
import style0 from "./mesh.vue?vue&type=style&index=0&id=19a756ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports